import { create } from "zustand";

export interface ProposalFilters {
  category: string;
  text: string;
  type: string[];
  products: string[];
  servicePoint: string[];
}
interface ProposalFilterState {
  filters: ProposalFilters;
  hasFilters: boolean;
  filtersCount: number;
  setFilters: (partialFilters: Partial<ProposalFilters>) => void;
  reset: () => void;
}

export const defaultValues: ProposalFilters = {
  text: "",
  category: "",
  type: [],
  products: [],
  servicePoint: []
};

export const useFilterStore = create<ProposalFilterState>()((set, get) => ({
  filters: defaultValues,
  hasFilters: false,
  filtersCount: 0,
  setFilters: (partialFilters: Partial<ProposalFilters>) => {
    const filters = get().filters;
    const newFilters = { ...filters, ...partialFilters };
    const ignoreKeys = ["category", "text"];

    // Filter count is used to show on the filter button, it counts all filters except the ones in ignoreKeys
    const filtersCount =
      Object.entries(newFilters).filter(([index, value]) => {
        if (ignoreKeys.includes(index)) return false;

        return value.length;
      }).length || 0;

    const hasFilters =
      Object.entries(newFilters).filter(([, value]) =>
        Array.isArray(value) ? value.length : value
      ).length > 0;

    return set({
      filters: newFilters,
      filtersCount,
      hasFilters
    });
  },
  reset: () => set({ filters: defaultValues })
}));

export default useFilterStore;
